import controller from './featured-products.controller';
import template from './featured-products.view.html';

let FeaturedProductsComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default FeaturedProductsComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/featured-products/featured-products.component.js
 **/